<script lang="ts" setup>
import { PageHeader } from '@/components/page-header';
import PageFooter from '@/components/PageFooter.vue';
import ScrollToTop from '@/components/ScrollToTop.vue';

defineOptions({
  name: 'LayoutNormal',
});
</script>

<template>
  <PageHeader />
  <slot />
  <PageFooter />
  <ScrollToTop />
</template>

<style lang="scss" scoped>
</style>
